'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = function (lowlight, defaultStyle) {
  return function SyntaxHighlighter(props) {
    var language = props.language,
        children = props.children,
        _props$style = props.style,
        style = _props$style === undefined ? defaultStyle : _props$style,
        _props$customStyle = props.customStyle,
        customStyle = _props$customStyle === undefined ? {} : _props$customStyle,
        _props$codeTagProps = props.codeTagProps,
        codeTagProps = _props$codeTagProps === undefined ? {} : _props$codeTagProps,
        _props$useInlineStyle = props.useInlineStyles,
        useInlineStyles = _props$useInlineStyle === undefined ? true : _props$useInlineStyle,
        _props$showLineNumber = props.showLineNumbers,
        showLineNumbers = _props$showLineNumber === undefined ? false : _props$showLineNumber,
        _props$startingLineNu = props.startingLineNumber,
        startingLineNumber = _props$startingLineNu === undefined ? 1 : _props$startingLineNu,
        lineNumberContainerStyle = props.lineNumberContainerStyle,
        lineNumberStyle = props.lineNumberStyle,
        rest = (0, _objectWithoutProperties3.default)(props, ['language', 'children', 'style', 'customStyle', 'codeTagProps', 'useInlineStyles', 'showLineNumbers', 'startingLineNumber', 'lineNumberContainerStyle', 'lineNumberStyle']);

    var codeTree = language ? lowlight.highlight(language, children) : lowlight.highlightAuto(children);
    var defaultPreStyle = style.hljs || { backgroundColor: '#fff' };
    var preProps = useInlineStyles ? (0, _assign2.default)({}, rest, { style: (0, _assign2.default)({}, defaultPreStyle, customStyle) }) : (0, _assign2.default)({}, rest, { className: 'hljs' });

    var lineNumbers = showLineNumbers ? _react2.default.createElement(LineNumbers, {
      containerStyle: lineNumberContainerStyle,
      numberStyle: lineNumberStyle,
      startingLineNumber: startingLineNumber,
      codeString: children
    }) : null;
    return _react2.default.createElement(
      'pre',
      preProps,
      lineNumbers,
      _react2.default.createElement(
        'code',
        codeTagProps,
        codeTree.value.map(function (node, i) {
          return createElement({
            node: node,
            style: style,
            useInlineStyles: useInlineStyles,
            key: 'code-segement' + i
          });
        })
      )
    );
  };
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createStyleObject(classNames, style) {
  return classNames.reduce(function (styleObject, className) {
    return (0, _extends3.default)({}, styleObject, style[className]);
  }, {});
}

function createClassNameString(classNames) {
  return classNames.join(' ');
}

function createChildren(style, useInlineStyles) {
  var childrenCount = 0;
  return function (children) {
    childrenCount += 1;
    return children.map(function (child, i) {
      return createElement({
        node: child,
        style: style,
        useInlineStyles: useInlineStyles,
        key: 'code-segment-' + childrenCount + '-' + i
      });
    });
  };
}

function createElement(_ref) {
  var node = _ref.node,
      style = _ref.style,
      useInlineStyles = _ref.useInlineStyles,
      key = _ref.key;
  var properties = node.properties,
      type = node.type,
      tagName = node.tagName,
      value = node.value;

  if (type === 'text') {
    return value;
  } else if (tagName) {
    var TagName = tagName;
    var childrenCreator = createChildren(style, useInlineStyles);
    var props = useInlineStyles ? { style: createStyleObject(properties.className, style) } : { className: createClassNameString(properties.className) };
    var children = childrenCreator(node.children);
    return _react2.default.createElement(
      TagName,
      (0, _extends3.default)({ key: key }, props),
      children
    );
  }
}

function getLineNumbers(_ref2) {
  var lines = _ref2.lines,
      startingLineNumber = _ref2.startingLineNumber,
      style = _ref2.style;

  return lines.map(function (_, i) {
    var number = i + startingLineNumber;
    return _react2.default.createElement(
      'span',
      {
        key: 'line-' + i,
        className: 'react-syntax-highlighter-line-number',
        style: typeof style === 'function' ? style(number) : style
      },
      number + '\n'
    );
  });
}

function LineNumbers(_ref3) {
  var codeString = _ref3.codeString,
      _ref3$containerStyle = _ref3.containerStyle,
      containerStyle = _ref3$containerStyle === undefined ? { float: 'left', paddingRight: '10px' } : _ref3$containerStyle,
      _ref3$numberStyle = _ref3.numberStyle,
      numberStyle = _ref3$numberStyle === undefined ? {} : _ref3$numberStyle,
      startingLineNumber = _ref3.startingLineNumber;

  return _react2.default.createElement(
    'code',
    { style: containerStyle },
    getLineNumbers({
      lines: codeString.replace(/\n$/, '').split('\n'),
      style: numberStyle,
      startingLineNumber: startingLineNumber
    })
  );
}


//////////////////
// WEBPACK FOOTER
// ../~/react-syntax-highlighter/dist/highlight.js
// module id = 2840
// module chunks = 0